import React from 'react';

import useGLMKiloRecords from 'hooks/glmFlows/useGLMKiloRecords';

import FlowRecordsModal, { UseRecordsFn } from './FlowRecordsModal';

const ModalGLMKiloRecords = ({
  opened,
  onClose,
  flowId,
  flowLabel,
}: {
  opened: boolean;
  onClose: () => void;
  flowId: string | null;
  flowLabel?: string;
}): JSX.Element => (
  <FlowRecordsModal
    opened={opened}
    onClose={onClose}
    flowId={flowId}
    flowLabel={flowLabel}
    direction='glm_to_kilo'
    useRecords={useGLMKiloRecords as UseRecordsFn}
  />
);

export default ModalGLMKiloRecords;
